/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  priceChart selectors
 */

import { priceChartDataSelectorsCreator, selectDetailPriceChart } from '../priceChart'

const detailPriceChartDataSelectors = priceChartDataSelectorsCreator(selectDetailPriceChart)

export const {
  selectCityPriceChartData,
  selectHoodPriceChartData,
  selectCityBedroomData,
  selectCitySeries,
  selectHoodBedroomData,
  selectHoodSeries,
  selectRecentPrice,
} = detailPriceChartDataSelectors
